import React from 'react';
var ItalicText = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 100 100" },
        React.createElement("polygon", { fill: fill, points: "64.274 100 66.49 90.262 47.394 90.262 66.064 9.738 85.16 9.738 87.377 0 35.753 0 33.537 9.738 52.633 9.738 33.962 90.262 14.866 90.262 12.65 100" })));
};
export default ItalicText;
